import React from 'react';

import RouteWrapper from './RouteWrapper';
import PlaylistsWrapper from './PlaylistsWrapper';
import AutomixWrapper from './library/automix/AutomixWrapper';
import HistoryWrapper from './HistoryWrapper';
import ShortcutsPanelWrapper from './library/shortcut/ShortcutsPanelWrapper';
import NavControlWrapper from './library/nav-control/NavControlWrapper';
import RecentTracksWrapper from './RecentTracksWrapper';

// Required Shared Module for the djapp
function RootWrapper() {
  return (
    <>
      <RouteWrapper />
      <PlaylistsWrapper />
      <AutomixWrapper />
      <HistoryWrapper />
      <ShortcutsPanelWrapper />
      <NavControlWrapper />
      <RecentTracksWrapper />
    </>
  )
}

export default RootWrapper;
